export const renderLabel = (label: string, { required }: { required: boolean }) => {
  if (required) {
    return `${label}*`;
  }

  return label;
};
